<template>
  <div v-if="user">
    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>
    <el-card v-else>
      <div slot="header">Apps</div>
      <table cellpadding="5" cellspacing="5" width="100%">
        <tr>
          <th align="left">Name</th>
          <th align="center">Role/Status</th>
        </tr>
        <tr v-for="(app, index) in apps" :key="index">
          <td align="left">{{ app.name }}</td>
          <td align="center">
            <edit-role-button :userMembership="userMembership(app.id)" :roles="app.roles"><i class="fas fa-pen"></i></edit-role-button>
          </td>
        </tr>
      </table>
    </el-card>
  </div>
</template>

<script>
  import { find } from 'lodash';
  import { mapActions, mapGetters } from 'vuex';

  import EditRoleButton from '@/components/role/EditRoleButton';

  export default {
    name: 'UserMembershipsList',
    props: {
      userId: {
        type: Number,
        required: true,
      },
    },
    components: {
      editRoleButton: EditRoleButton,
    },
    created() {
      this.fetchApps();
    },
    computed: {
      ...mapGetters('entities/apps', ['fetching']),
      ...mapGetters('entities/companies', ['isAppSubscribed']),

      apps() {
        return this.$store.getters['entities/apps/query']()
          .with('roles')
          .get();
      },
      user() {
        return this.$store.getters['entities/users/query']()
          .with('profile')
          .with('user_memberships')
          .where('id', this.userId)
          .first();
      },
    },
    methods: {
      ...mapActions('entities/apps', ['fetchApps']),
      ...mapActions('entities/userMembership', ['openFormModal']),

      userMembership(appId) {
        return find(this.user.user_memberships, { app_id: appId });
      },
      role(appId) {
        return this.$store.getters['entities/roles/query']()
          .where('app_id', appId)
          .first();
      },
    },
  };
</script>
<style lang="scss" scoped>
  ul{
    padding: 0;
    margin: 0;
  }

  h3{
    margin-top: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/userMembership/UserMembershipsList.vue